module.exports = __webpack_public_path__ + "assets/img/chirp-profile.2ac3a48c.svg";